const faraway = {
  path: 'faraway',
  component: resolve => require(['../../../../../../pages/admin/merchant/dispose/farAway'], resolve),
  meta: {
    requireAuth: true
  }
}

export default faraway